(function () {
  'use strict';

  class SvgInjector {
    constructor() {
      this.imageEl = document.querySelectorAll('img[src*=".svg"]');

      this.inject = this.inject.bind(this);
      this.handleImages();
    }

    handleImages() {
      const self = this;
      Array.from(this.imageEl).forEach(function (image) {
        if (image.getAttribute('src')) {
          self.inject(image);
        }
      });
    }

    inject(image) {
      const imageId = image.getAttribute('id');
      const imageClass = image.getAttribute('class');
      const imageSrc = image.getAttribute('src');
      const imageAlt = image.getAttribute('alt');
      const xhr = new XMLHttpRequest();
      xhr.open('GET', imageSrc);
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
          const xml = xhr.responseXML;
          const node = xml.getElementsByTagName('svg')[0];
          let imageID;

          if (typeof imageId !== 'undefined' && imageId !== null) {
            node.setAttribute('id', imageID);
          }

          if (typeof imageClass !== 'undefined' && imageClass !== null) {
            node.setAttribute('class', imageClass + ' replaced-svg');
          } else {
            node.setAttribute('class', 'replaced-svg');
          }

          if (typeof imageAlt !== 'undefined' && imageAlt !== '') {
            const titleNode = xml.createElement('title');
            titleNode.appendChild(xml.createTextNode(imageAlt));
            node.insertBefore(titleNode, node.childNodes[0]);
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          node.removeAttribute('xmlns:a');

          image.parentNode.insertBefore(node, image);
          image.remove();
        }
      };
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.send();
    }
  }

  new SvgInjector();
})();
